import Filter from "./Filter";
import ListData from "./ListData";
import TableData from "./TableData";

const activityLogsComponents = {
  Filter,
  ListData,
  TableData,
}

export default activityLogsComponents